var wallpaperChecker = null,
    wallpaperPresent = false,
    wallpaperCheckerCounter = 0,
    maxAttempts = 20,
    wallpaperCheckerInterval = 1000,
    registeredWallpaperCallbacks = []


if(typeof window === 'object' && window.location.pathname === '/'){
    console.log("wallpaperChecker has started, will check %s times max",maxAttempts)
    wallpaperChecker = setInterval(checkForWallpaper,wallpaperCheckerInterval)
}


function checkForWallpaper(){
  if(document.getElementsByTagName('body')[0].id === 'WallpaperAd')
    wallpaperFound()

  wallpaperCheckerCounter++
  if(wallpaperCheckerCounter >= maxAttempts){
      clearInterval(wallpaperChecker)//stop checking
      console.log('wallPaperChecker timed out after %s', maxAttempts)
  }

}

function register(callback){
  if(wallpaperPresent){
    callback()
    return
  }
  registeredWallpaperCallbacks.push(callback)
}

function wallpaperFound(){
  wallpaperPresent = true;

  clearInterval(wallpaperChecker)
  registeredWallpaperCallbacks.map(function(f,i,a){
    console.log('wallpaper checker fired registered function # %s',i)
    f()
  })


}




export default {
  register : register,
  wallpaperPresent : wallpaperPresent
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WallpaperChecker.js